import React from "react";

/**
 * TaxStatusBadge - Shows tax status with appropriate icon and color
 *
 * @param {string} taxStatus - The tax status: TAXABLE, TAX_DEFERRED, TAX_FREE, HSA
 * @param {boolean} showLabel - Whether to show the text label (default: true)
 * @param {string} size - Size: 'sm', 'md', 'lg' (default: 'md')
 */
const TaxStatusBadge = ({ taxStatus, showLabel = true, size = "md" }) => {
  if (!taxStatus) return null;

  const configs = {
    TAXABLE: {
      icon: "💰",
      label: "Taxable",
      bgColor: "bg-blue-100 dark:bg-blue-900",
      textColor: "text-blue-800 dark:text-blue-200",
      description: "Regular brokerage account",
    },
    TAX_DEFERRED: {
      icon: "🔒",
      label: "Tax-Deferred",
      bgColor: "bg-purple-100 dark:bg-purple-900",
      textColor: "text-purple-800 dark:text-purple-200",
      description: "Traditional IRA, 401(k)",
    },
    TAX_FREE: {
      icon: "🎁",
      label: "Tax-Free",
      bgColor: "bg-green-100 dark:bg-green-900",
      textColor: "text-green-800 dark:text-green-200",
      description: "Roth IRA, Roth 401(k)",
    },
    HSA: {
      icon: "🏥",
      label: "HSA",
      bgColor: "bg-orange-100 dark:bg-orange-900",
      textColor: "text-orange-800 dark:text-orange-200",
      description: "Health Savings Account",
    },
  };

  const config = configs[taxStatus] || configs.TAXABLE;

  const sizeClasses = {
    sm: "text-xs px-2 py-0.5",
    md: "text-sm px-2.5 py-1",
    lg: "text-base px-3 py-1.5",
  };

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-medium ${config.bgColor} ${config.textColor} ${sizeClasses[size]}`}
      title={config.description}
    >
      <span>{config.icon}</span>
      {showLabel && <span>{config.label}</span>}
    </span>
  );
};

export default TaxStatusBadge;
